import LayoutSimple from "./LayoutSimple";

export default LayoutSimple;
